export default "__VITE_ASSET__BxnEIm_b__"